import { AccountType } from "../../@types/account";
import { FormType } from "../../@types/form";
import { ProfileType } from "../../@types/profile";
import { getPaymentMethods } from "../paymentMethods";

export const transformAccountToProfile = (
  account: AccountType
): ProfileType => {
  const paymentMethods = getPaymentMethods();
  const isPaymentMethodValid = Object.keys(paymentMethods).includes(
    account.attributes.paymentMethod
  );

  return {
    balance: account.attributes.accountBalance,
    createdAt: account.attributes.created_at,
    email: account.attributes.email,
    firstName: account.attributes.firstName,
    id: parseInt(account.id, 10),
    lastName: account.attributes.lastName,
    paymentMethod: isPaymentMethodValid
      ? (account.attributes.paymentMethod as FormType)
      : null,
    stripeBankName: account.attributes.stripeBankName,
    stripeBankAccountType: account.attributes.stripeBankAccountType,
    stripeBankLastFour: account.attributes.stripeBankLastFour,
    paypalAddress: account.attributes.paypalAddress,
    requestedStoreCredit:
      parseFloat(account.attributes.requestedStoreCredit) || 0.0,
    banned: account.attributes.banned,
    sellerBanned: account.attributes.sellerBanned,
    updatedAt: null,
    userId: parseInt(account.id, 10),
    market: account.attributes.market || "US",
  };
};
